import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';
import * as actions from '../../actions';

import NotFoundPage from '../NotFoundPage';

import numberFormat from '../../utils/numberFormat';
import getImageUrl from '../../utils/getImageUrl';

import ReceivedCouponsView from './receiveds'

export class MorePage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 새로고침 된 경우 최상단으로 스크롤 됨.
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 500);
  }

  render() {
    const { device, showModal, entities } = this.props;
    const { received } = entities;

    return (
      <div id="kakaoWrap">
        <div id="kakaoContent" className="cont_coupon" style={{ marginTop: 0 }}>
          <ReceivedCouponsView type={'global'}
            receivedCoupons={[]}
          />
        </div>
        <div id="kakaoFoot" className="foot_coupon">
          <span className="ico_coupon">카카오톡 채널</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, entities } = state;
  return { device, entities };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(MorePage);



// WEBPACK FOOTER //
// ./src/containers/MorePage/global.js